import { render, staticRenderFns } from "./Account.vue?vue&type=template&id=efe4c654"
import script from "./js/Account.js?vue&type=script&lang=js&external"
export * from "./js/Account.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports